import React, { useState, useEffect, useContext } from "react";
import { TextField, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, Button, Typography, Grid, FormControl, InputLabel, Box } from "@mui/material";
import { ThemeContext } from "../../../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import { useSymbolPrices } from "../../../../context/WebSocketContext";
import BidValue from "../../../global/BidAsk/BidValue";
import AskValue from "../../../global/BidAsk/AskValue";
import { useSelector } from "react-redux";


const EditAlertDialog = ({ open, handleClose, alertData, handleSave, symbolData, handleUpdate, digit }) => {
    const [formData, setFormData] = useState({ ...alertData });
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    // const symbols = useSymbolPrices();
    const { symbols } = useSelector(state => state.watchlist)


    useEffect(() => {
        if (alertData) {
            setFormData({ ...alertData });
        }

    }, [alertData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        handleUpdate(formData);
        handleClose();
    };

    const selectedSymbol = symbols[alertData?.symbolId];
    const bid = selectedSymbol ? selectedSymbol.bid : null;
    const ask = selectedSymbol ? selectedSymbol.ask : null;
    const digits = selectedSymbol ? selectedSymbol.digits : null
    // console.log(selectedSymbol);


    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ color: "white", p: 1 }} className="bg-primary">
                <Typography id="symbol-details-modal" variant="body1" sx={{ color: darkMode ? "var(--white)" : "var(--white)" }} align="center" >{t('EditAlerts')}</Typography>
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={6} alignItems="center" justifyContent="center" display='flex' flexDirection="column">
                        <Typography variant="body1" align="center" >{t('bid')}</Typography>
                        {/* <Typography variant="body1" align="center" sx={{ color: selectedSymbol?.bidColor === "up" ? "#079a80" : selectedSymbol?.bidColor === "down" ? "#da5244" : "inherit" }}>
                            {bid ? bid.toFixed(digits) : 'NA'}</Typography> */}
                        <BidValue symbolId={selectedSymbol?.id} digits={digits} />

                    </Grid>
                    <Grid item xs={6} alignItems="center" justifyContent="center" display='flex' flexDirection="column">
                        <Typography variant="body1" align="center">{t('ask')}</Typography>
                        {/* <Typography variant="body1" align="center" sx={{ color: selectedSymbol?.askColor === "up" ? "#079a80" : selectedSymbol?.askColor === "down" ? "#da5244" : "inherit" }}>
                            {ask ? ask.toFixed(digits) : 'NA'}</Typography> */}
                        <AskValue symbolId={selectedSymbol?.id} digits={digits} />

                    </Grid>
                </Grid>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, }}>

                    {/* <TextField sx={{ "& .MuiOutlinedInput-root": { height: 45 } }} fullWidth label="Description" name="description" value={formData.description || ""} onChange={handleChange} /> */}

                    <FormControl fullWidth >
                        <InputLabel>{t('type')}</InputLabel>
                        <Select label={t('type')} name="type" value={formData.type || ""} onChange={handleChange} sx={{ height: 45 }}>
                            <MenuItem value={1}>{t("MarketAsk")}</MenuItem>
                            <MenuItem value={2}>{t('MarketBid')}</MenuItem>
                            <MenuItem value={3}>{t('balance')}</MenuItem>
                            <MenuItem value={4}>{t('equity')}</MenuItem>
                            <MenuItem value={5}>{t('MarginLevel')}</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth >
                        <InputLabel>{t('condition')}</InputLabel>
                        <Select label={t('condition')} name="condition" value={formData.condition || ""} onChange={handleChange} sx={{ height: 45 }}>
                            <MenuItem value={1}>{t('greaterThan')}</MenuItem>
                            <MenuItem value={2}>{t('lessThan')}</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth>
                        <InputLabel>{t('SymbolList')}</InputLabel>
                        <Select label={t('SymbolList')} name="symbol" value={formData.symbolId || ""} onChange={handleChange} sx={{ height: 45 }}>
                            {Object.values(symbolData).map((symbol) => (
                                <MenuItem key={symbol.id} value={symbol.id}>{symbol.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                    <FormControl fullWidth>
                        <TextField name="hitPrice" type="number" value={formData.hitPrice || ""} onChange={handleChange} variant="outlined" sx={{ height: 45 }} />
                    </FormControl>

                </Box>
            </DialogContent>

            <DialogActions sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Button onClick={handleClose} variant="outlined" color="primary">{t('cancel')}</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">{t('save')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditAlertDialog;
